'use client'

import { useEffect, useState } from 'react'
import SalesLetter from './components/sales-letter'
import ContactForm from './components/contact-form'
import DynamicHead from '@/components/DynamicHead'
import { useDomain } from '@/hooks/useDomain'
import JsonLd from '@/components/json-ld'
import { generateWebPageSchema, generateOrganizationSchema } from '@/utils/schema-generator'

export default function Home() {
  const [isClient, setIsClient] = useState(false)
  const { city } = useDomain()
  const domain = `${city.replace(/\s+/g, '')}Orthopedic.com`

  const pageSchema = generateWebPageSchema({
    title: `Orthopedic Services in ${city}`,
    description: `Premier orthopedic services in ${city}`,
    domain,
    path: '/',
    datePublished: '2024-01-01',
    dateModified: new Date().toISOString()
  })

  const orgSchema = generateOrganizationSchema({
    name: `${city} Orthopedic`,
    logo: '/logo.png',
    domain,
    url: `https://${domain}`,
    description: `Leading orthopedic services provider in ${city}`
  })

  useEffect(() => {
    setIsClient(true)
  }, [])

  if (!isClient) {
    return null // or a loading state
  }
  
  return (
    <>
      <JsonLd data={pageSchema} />
      <JsonLd data={orgSchema} />
      <div className="min-h-screen bg-blue-50">
        <DynamicHead />
        <main className="container mx-auto px-4 py-8 max-w-4xl">
          <h1 className="text-4xl font-bold text-blue-800 mb-8 text-center">
            Secure Your Digital Presence
          </h1>
          <SalesLetter city={city} />
          <ContactForm />
        </main>
      </div>
    </>
  )
}